








import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { tns } from "tiny-slider/src/tiny-slider";
import TeamCard from "./team-card.vue";

@Component({
    components: {
        TeamCard
    }
})
export default class TeamSlider extends Vue {
    @Prop() team!: any;

    @Ref() readonly teamSlider!: HTMLElement;

    slider: any = null;

    private mounted() {
        // @ts-ignore
        /*         if (this.$root.$mq === "sm" || false) {
            this.initSlider();
        } */
    }

    private initSlider() {
        this.$nextTick(() => {
            this.$nextTick(() => {
                // @ts-nocheck
                this.slider = tns({
                    container: this.teamSlider,
                    items: 1.1,
                    gutter: 24,
                    preventScrollOnTouch: "force",
                    mouseDrag: true,
                    loop: false,
                    controls: false,
                    swipeAngle: false,
                    nav: false,
                    responsive: {
                        768: {
                            items: 2.1,
                            gutter: 24
                        },
                        1024: {
                            items: 2.5,
                            gutter: 30
                        },
                        1640: {
                            items: 4,
                            gutter: 60
                        }
                    }
                });
            });
        });
    }
}
